import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BEARER_ONLY, BYPASS_HEAD } from '../interceptor/token.interceptor';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import * as fromAccountActions from '../store/actions/account.action';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private injector: Injector
  ) { }

  userProfile(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/user/details', { withCredentials: true });
  }

  submitCollegeApplication(course_id: any, curriculum_id: any, item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/forms/${course_id}/${curriculum_id}/college`, item, { withCredentials: true, context: new HttpContext().set(BEARER_ONLY, true) },);
  }

  submitSeniorHighApplication(course_id: any, curriculum_id: any, item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/forms/${course_id}/${curriculum_id}/senior`, item, { withCredentials: true, context: new HttpContext().set(BEARER_ONLY, true) },);
  }

  getStudentApplication(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/forms/student-application', { withCredentials: true });
  }

  getPreEnrollmentRequirements(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/documents/pre-enrollment/requirements', { withCredentials: true });
  }

  submitRequirements(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/documents/pre-enrollment/requirements/upload', item, { withCredentials: true, context: new HttpContext().set(BEARER_ONLY, true) },);
  }

  getAcademicRequirements(type): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `api/v1/documents/academic/requirements/${type}`, { withCredentials: true });
  }

  getPresignedUrl(requirementId, file) {
    const postData = {
      requirement_id: requirementId,
      file_name: file.file_name,
      mime_type: file.mime_type
    };
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/documents/pre-enrollment/requirements/presigned-url', JSON.stringify(postData), { withCredentials: true, context: new HttpContext().set(BEARER_ONLY, true) });
  }

  uploadToS3(file, url) {
    return this.http.put<any>(url, file, { headers: { 'Content-Type': file.type, 'Accept': 'application/json' }, context: new HttpContext().set(BYPASS_HEAD, true) });
  }

  submitAcademicRequirements(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/documents/academic/requirements/upload', item, { withCredentials: true, context: new HttpContext().set(BEARER_ONLY, true) });
  }

  submitEnrollment(): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/student/submit-enrollment', '', { withCredentials: true });
  }

  submitPreEnlistment(schoolYearTerm): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/student/${schoolYearTerm}/pre-enlistment`, '', { withCredentials: true });
  }

  getCurriculumCompletion(student_id): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `api/v1/student/${student_id}/curriculum-completion`, { withCredentials: true });
  }

  getLatestEnrollmentStatus(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/student/latest-enrollment-status', { withCredentials: true });
  }

  /** Status → route map for all applicant workflow states. */
  private readonly STATUS_ROUTES: Record<string, string> = {
    'new':                               '/student/pre-enrollment',
    'pre_enrollment_requirements':       '/student/first-interview',
    'first_interview_scheduled':         '/student/first-interview',
    'first_interview_scheduled_failed':  '/student/first-interview',
    'first_interview_scheduled_passed':  '/student/academic-requirements',
    'academic_requirements':             '/student/second-interview',
    'second_interview_scheduled':        '/student/second-interview',
    'second_interview_scheduled_failed': '/student/second-interview',
    'second_interview_scheduled_passed': '/student/loa',
    'await_loa':                         '/student/loa',
    'sent_loa':                          '/student/loa',
    'complete':                          '/student/welcome',
  };

  getLatestNote(notes: any[]): any {
    if (!notes || !Array.isArray(notes) || notes.length === 0) return null;
    try {
      // Safely sort notes by ID descending (highest ID first = latest note)
      return [...notes].sort((a, b) => (b?.id || 0) - (a?.id || 0))[0];
    } catch (e) {
      return notes[notes.length - 1];
    }
  }

  checkStatus(notes: any[]): void {
    const latestNote = this.getLatestNote(notes);
    const status: string = latestNote?.status ?? '';
    
    if (status === 'complete') {
      const store = this.injector.get(Store);
      store.dispatch(fromAccountActions.getLatestEnrollmentStatus());
      return;
    }

    const route = this.STATUS_ROUTES[status] ?? '/student/welcome';
    this.router.navigateByUrl(route);
  }
}
